<script setup lang="ts">
import { useI18n } from 'petite-vue-i18n';
import { TEXT } from '../../configs/text';
import Button from '../General/Button.vue';
import Heading from '../General/Heading.vue';
import Modal from '../General/Modal.vue';
import { ref } from 'vue';
import { useAuthStore } from '../../stores';
import LogoutIcon from '../../assets/icons/logout.svg';
import SettingIcon from '../../assets/icons/settings.svg';
import ChangeLanguage from './ChangeLanguage.vue';

const auth = useAuthStore()

const modalSettingsShow = ref<boolean>(false)
const modalLogoutShow = ref<boolean>(false)

function openSettings() {
    modalSettingsShow.value = true
}

function openLogoutModal() {
    modalLogoutShow.value = true
}

function handleLogoutConfirm() {
    auth.logout()
    modalLogoutShow.value = false
}


const { t } = useI18n()
</script>

<template>
    <Button @click="openSettings" color="main" class="!p-2 size-10">
        <SettingIcon class="size-5" />
    </Button>

    <Modal v-model="modalSettingsShow">
        <Heading alignment="center">{{ t(TEXT.settings) }}</Heading>
        <ChangeLanguage class="mt-5" />
        <div class="flex mt-7 mb-3 justify-center" v-if="auth.isAuthenticated">
            <Button @click="openLogoutModal" color="main">
                <LogoutIcon />
                <span>{{ t(TEXT.logout) }}</span>
            </Button>
        </div>
    </Modal>

    <Modal v-model="modalLogoutShow">
        <Heading alignment="center">{{ t(TEXT.logout) }}</Heading>
        <div class="text-center my-7" v-html="t(TEXT.logout_confirm)"></div>
        <Button color="warning" class="mx-auto" @click="handleLogoutConfirm">
            {{ t(TEXT.yes) }}
        </Button>
    </Modal>
</template>